import { emailValidaotr, gstinValidator, mandatoryFieldValditor, mobileValidator, pinCodeValidator } from 'common/utils/validator';
import { formElement } from 'dedicated/components/summary/summary.constant';

export const KEYS_TO_IGNORE = ['touched', 'gstin'];

export const formSchema = {
  pinCode: { ...formElement, validator: pinCodeValidator },
  city: { ...formElement },
  address: { ...formElement, validator: mandatoryFieldValditor },
  personName: { ...formElement, validator: mandatoryFieldValditor },
  mobileNumber: { ...formElement, validator: mobileValidator },
  email: { ...formElement, validator: emailValidaotr },
  gstin: { ...formElement, validator: gstinValidator }
};

const setBCP = (billingContactDetails) => {
  if (billingContactDetails) {
    formSchema.email.value = billingContactDetails.email || '';
    formSchema.mobileNumber.value = billingContactDetails.phoneNumber || '';
    formSchema.personName.value = billingContactDetails.firstName || '';
  }
};

export const getDefaultValue = (order) => {
  const {
    fiscalCode,
    gstNumber,
    billingLevel,
    billingAddress,
    parentAccountNumber,
    billingContactDetails,
    companyAddress: { addressLine1 },
    lead: { customer }
  } = order;
  let cityObj = {};
  cityObj.displayName = billingAddress && billingAddress.city;
  cityObj.key = billingAddress && billingAddress.city;
  formSchema.pinCode.value = billingAddress && billingAddress.pincode ? billingAddress.pincode : '';
  formSchema.pinCode.touched = true;
  formSchema.address.value =
    billingAddress && billingAddress.addressLine1 ? billingAddress.addressLine1 + (billingAddress.addressLine2 ? ` ${billingAddress.addressLine2}` : '') : '';
  formSchema.city.value = cityObj;
  setBCP(billingContactDetails);
  formSchema['gstin']['value'] = (fiscalCode?.type === 'GST' && fiscalCode?.id ? fiscalCode.id : '') || gstNumber || '';

  return formSchema;
};
